import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import dfilters from './filters/index'

// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'


import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)


// import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import {faUser,} from '@fortawesome/free-solid-svg-icons';
// library.add(
//     faUser,
// );
// Vue.component('font-awesome-icon', FontAwesomeIcon);

import vueTimerCountdown from 'vue-timer-countdown'
Vue.use(vueTimerCountdown, { component: 'TimerCountdown' }) // 组件名默认是：timer-countdown



for (let key in dfilters) {
  Vue.filter(key, dfilters[key]);
}

Vue.config.productionTip = false
Vue.use(ElementUI);
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

import animated from 'animate.css' // animate.css 动画库
Vue.use(animated)

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer, {
  background: {     // or : background: '#000'
    color: '#000' // or rgba or rgb     // or image: 'url(xxx)'
  },
  previewSize: 2, //三倍图
  // transition
  // loading (not supported)
  loading: {
    image: ''
  },
  // cursor(css)
  cursor: 'pointer',
  clickMethod: 'doubleClick'   // click or doubleClick(not supported)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
